import { Box, Button, Modal, Typography, useTheme } from "@mui/material";
import { EnuinStatusObj } from "../../../redux-store/types/api-types";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    }
}

export default function EUINPopup(props: { open: boolean, setClose: any, euinRes: EnuinStatusObj, handleEuinCheckClose: any }): JSX.Element {
    const { open, setClose, euinRes, handleEuinCheckClose } = props;
    if(!open) return <></>;
    const theme = useTheme();
    console.log('euinRes', euinRes)
    return (
        <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby={"title"}
            aria-describedby={'form-modal'}
        >
            <Box
                sx={style}
            >
                <Typography variant='h2' color={theme.palette.text.primary}>{euinRes.message || 'Something went wrong'}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '48px' }}>
                    <Button
                        onClick={setClose}
                        variant="outlined"
                        fullWidth
                        sx={{
                            borderRadius: '4px',
                            textTransform: 'none',
                            ...theme.typography.body_500,
                            color: theme.palette.text.primary
                        }}
                    >
                        Close
                    </Button>
                    {euinRes?.isValid && <Button
                        onClick={handleEuinCheckClose}
                        variant="contained"
                        fullWidth
                        sx={{
                            borderRadius: '4px',
                            textTransform: 'none',
                            ...theme.typography.body_500,
                        }}
                    >
                        Continue
                    </Button>}
                </Box>
            </Box>
        </Modal >
    )
}